import styled from 'styled-components';
import { Messaging } from 'themes/rebrand/colours';
import { BREAKPOINTS } from 'constants/breakpoints';

const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

export const RecommendedStationArrivalTimeLoader = styled.span`
  display: block;
  opacity: 0.25;

  &::before {
    content: '...';
  }
`;

export const StyledRecommendedStationArrivalTimeMessage = styled.div`
  display: inline-block;
  font-size: 0.77em;
  color: ${Messaging.WarningOrange};

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: inline-flex;
    text-wrap: wrap;
    line-height: normal;
  }
`;
